/* eslint-disable */
import React, { useState } from "react";
import "contents/assets/scss/page/promotion.scss";
import Paging from "../../component/Inc/Paging";
import Tab from "../../component/Inc/Tab";

const PRList = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    { title: "전체", value: 0 },
    { title: "재전화 요청", value: 1 },
    { title: "시범강의 요청", value: 2 },
  ];
  return (
    <main className="com_container p_pr_list">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_5">
            홍보하기
            <span className="bar" />
            <span className="point_txt">김교사103</span>
          </h2>
          <button className="com_btn orange s btn_plus">전화수신 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <div className="flex_row">
                <div className="call">
                  <div className="default_tit">전화하기</div>
                  <button className="com_btn btn_call_orange"></button>
                  <div className="txt">010-1234-1344 님과 통화중...</div>
                </div>
                <div className="hang_up">
                  <div className="default_tit">전화하기</div>
                  <button className="com_btn btn_hang_up_orange"></button>
                </div>
                <div className="input_num">
                  <div className="default_tit">
                    전화번호
                    <br />
                    직접 입력
                  </div>
                  <button className="com_btn btn_keypad"></button>
                </div>
                <div className="com_board_box">
                  <div className="board_item">
                    <div className="info">
                      <span className="tit">통화시간</span>
                      <span className="cont com_blue_txt">2시간 30분</span>
                    </div>
                    <div className="info">
                      <span className="tit">통화 개수</span>
                      <span className="cont">645</span>
                    </div>
                    <div className="info">
                      <span className="tit">시범강의 요청</span>
                      <span className="cont">2시간 30분</span>
                    </div>
                    <div className="info">
                      <span className="tit">등록학생 수업</span>
                      <span className="cont">45</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx}  tabStyle="fit_cont"/>
              <section className="com_board_search">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">1개월</button>
                  <button className="com_btn line gray s">3개월</button>
                </div>
                <div className="date_wrap">
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <span className="divider"> ~ </span>
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>

            <table className="com_board_list">
              <colgroup>
                <col width="7%" />
                <col width="12%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="7%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>통화일</th>
                  <th>비고</th>
                  <th>전화번호</th>
                  <th>통화시간</th>
                  <th>통화 상태</th>
                  <th>메모</th>
                  <th>담임선생님</th>
                  <th>시범강의</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>17</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>아웃</td>
                  <td>010-1234-1324</td>
                  <td>1시간 30분</td>
                  <td>통화 불가</td>
                  <td>성격은 좋으나..</td>
                  <td className="td_point">_</td>
                  <td className="td_point">-</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>인</td>
                  <td>010-1234-1324</td>
                  <td>1시간 30분</td>
                  <td>통화 불가</td>
                  <td>성격은 좋으나..</td>
                  <td>
                    <button className="btn_link blue">김담임103</button>
                  </td>
                  <td className="td_point">-</td>
                </tr>
                <tr className="selected">
                  <td>15</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>아웃</td>
                  <td>010-1234-1324</td>
                  <td>1시간 30분</td>
                  <td>통화 불가</td>
                  <td>성격은 좋으나..</td>
                  <td className="td_point">_</td>
                  <td>
                    <button className="btn_link blue">
                      승인
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{14 - idx}</td>
                      <td className="td_date">2023, 05, 20 12 : 30</td>
                      <td>아웃</td>
                      <td>010-1234-1324</td>
                      <td>1시간 30분</td>
                      <td>통화 불가</td>
                      <td>성격은 좋으나..</td>
                      <td className="td_point">_</td>
                      <td className="td_point">-</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">전화수신 상세내용</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <p className="date dot">1시간 30분</p>
              <div className="count">
                <button className="btn_edit" />
                <button
                  type="button"
                  className="btn_arrow_down_circle"
                ></button>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김관리103</button>
                    <span className="date dot">2025, 05, 20 11 : 30</span>
                    <p className="date dot">010-1234-3122</p>
                    <p className="date dot">1시간 30분</p>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">발신 번호</span>
                  <span className="cont">010-1234-134</span>
                </div>
                <div className="info">
                  <span className="tit inline">수신자 명</span>
                  <span className="cont">
                    <input
                      type="text"
                      className="input lightGray"
                      defaultValue={`수신자 명`}
                    />
                  </span>
                </div>
              </div>
            </div>

            <div className="chat_box">
              <div className="msg_list">
                <div className="author">010-1234-4567</div>
                <div className="msg">네 안녕하세요. 무슨 일이시죠?</div>
              </div>
              <div className="msg_list">
                <div className="author">홍길동103</div>
                <div className="msg">
                  네 다름이 아니라 이지 수능 교육입니다.
                </div>
              </div>
            </div>
            <div className="com_input_wrap">
              <div className="check">
                <input
                  type="radio"
                  name="rdo"
                  id="rdo01"
                  className="com_chk circle"
                />
                <label htmlFor="rdo01">재전화 요청</label>
                <input
                  type="radio"
                  name="rdo"
                  id="rdo02"
                  className="com_chk circle"
                />
                <label htmlFor="rdo02">재전화 불가</label>
                <input
                  type="radio"
                  name="rdo"
                  id="rdo03"
                  className="com_chk circle "
                />
                <label htmlFor="rdo03">호의적</label>
                <input
                  type="radio"
                  name="rdo"
                  id="rdo04"
                  className="com_chk circle "
                />
                <label htmlFor="rdo04">관심없음</label>
              </div>
              <textarea className="textarea" placeholder="메모 입력"></textarea>
            </div>
            <div className="com_btn_wrap">
              <button className="com_btn orange xs btn_phone_black">
                전화 하기
              </button>
              <div className="flex_row">
                <button className="com_btn black xs btn_plus_orange">
                  홍보책자 발송
                </button>
                <button className="com_btn black xs btn_plus_orange">
                  시범강의 신청
                </button>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">등록</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default PRList;
